const toFeatureFlagKey = feature => feature.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);

export const planFeatureFlags = ({ features, planFeatures }) =>
  Object.keys(features).map(feature => ({
    key: toFeatureFlagKey(feature),
    onInPlan: (planFeatures ?? []).includes(feature),
  }));

export const featureFlagChoice = (featureFlags, key) => {
  const value = featureFlags?.[key];
  if (value === true) return 'on';
  if (value === false) return 'off';
  return 'plan';
};

const CHOICE_VALUES = { on: true, off: false, plan: null };

export const featureFlagUpdate = (key, choice) => ({ feature_flags: { [key]: CHOICE_VALUES[choice] } });
